import React from 'react';
import PropTypes from 'prop-types';

const TextWithTooltip = ({ text, tooltip }) => (
  <div className="text-with-tooltip position-relative">
    {text}
    {tooltip}
  </div>
);

TextWithTooltip.propTypes = {
  text: PropTypes.string,
  tooltip: PropTypes.object,
};

export default TextWithTooltip;



// WEBPACK FOOTER //
// ./library/app/components/Global/Tooltips/TextWithTooltip.js